<div class="popover popover--{{ direction }}">
  <ng-template [ngTemplateOutlet]="content"></ng-template>
</div>
